//DUCKS pattern
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import AppContext from 'app/common/context/AppContext';
import { TimePeriod } from 'app/model/CORE';

//type of the state managed by the reducer
interface TimeDataState {
    currentTime: Date;
    monitoredPeriod: TimePeriod;
}

const initialState: TimeDataState = {
    //empty
    currentTime: AppContext.getCurrentTime(),
    monitoredPeriod: AppContext.getMonitoringPeriod(),
};

const timeDataSlice = createSlice({
    name: 'mapSettingsData', // string that will be used as the prefix for generated action types
    initialState,
    reducers: {
        setCurrentTime(state: TimeDataState, action: PayloadAction<Date>) {
            state.currentTime = action.payload;
        },
        setMonitoredPeriod(state: TimeDataState, action: PayloadAction<TimePeriod>) {
            state.monitoredPeriod = action.payload;
        },
    },
    extraReducers(builder) {},
});

export const { setCurrentTime, setMonitoredPeriod } = timeDataSlice.actions;
export default timeDataSlice.reducer;
